/*
 * premierstreets
 * version 4.5
 * http://www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Store } from '@ngrx/store';
import * as cartAction from './action/cart.action';
import * as store from '../state.interface';
import {
  cartList,
  addToCart,
  addToCartFailed,
  addToCartLoaded,
  addToCartLoading,
  cartCount,
  cartCountFailed,
  cartCountLoaded,
  cartCountLoading,
  AddToCartValid, deleteFromCartFailed, deleteFromCartLoaded, deleteFromCartLoading, DeleteFromCart, shippingMethods, selectedShippingMethod, selectedUpsMethod, selectedAddress, userDetails, getShippingAmount, billingAddress
} from './reducer/cart.selector';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class CartSandbox {
  /* get cart count status*/
  public cartCount$ = this.appState$.select(cartCount);
  public userDetails$ = this.appState$.select(userDetails);
  public shippingAmount$ = this.appState$.select(getShippingAmount);
  public shippingMethods$ = this.appState$.select(shippingMethods);
  public selectedShippingMethod$ = this.appState$.select(selectedShippingMethod);
  public selectedUpsMethod$ = this.appState$.select(selectedUpsMethod);
  public selectedAddress$ = this.appState$.select(selectedAddress);
  public billingAddress$ = this.appState$.select(billingAddress);
  public cartCountLoading$ = this.appState$.select(cartCountLoading);
  public cartCountLoaded$ = this.appState$.select(cartCountLoaded);
  public cartCountFailed$ = this.appState$.select(cartCountFailed);
  /* get addToCart status*/
  public addToCart$ = this.appState$.select(addToCart);
  public addToCartValid$ = this.appState$.select(AddToCartValid);
  public addToCartLoading$ = this.appState$.select(addToCartLoading);
  public addToCartLoaded$ = this.appState$.select(addToCartLoaded);
  public addToCartFailed$ = this.appState$.select(addToCartFailed);
  public deleteFromCart$ = this.appState$.select(DeleteFromCart);
  public deleteFromLoading$ = this.appState$.select(deleteFromCartLoading);
  public deleteFromLoaded$ = this.appState$.select(deleteFromCartLoaded);
  public deleteFromFailed$ = this.appState$.select(deleteFromCartFailed);

  public cartList$ = this.appState$.select(cartList);


  constructor(
    protected appState$: Store<store.AppState>,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {

    if (isPlatformBrowser(this.platformId)) {
      const shippingMethod = localStorage.getItem('shippingMethod');

      if (shippingMethod) {
        this.selectShippingMethod(shippingMethod);
      }

      const userDetails = localStorage.getItem('userDetails');

      if (userDetails) {
        this.setUserDetails(JSON.parse(userDetails));
      }

      const shippingMethods = localStorage.getItem('shippingMethods');

      if (shippingMethods) {
        this.setShippingMethods(JSON.parse(shippingMethods));
      }

      const selectedAddress = localStorage.getItem('selectedAddress');

      if (selectedAddress) {
        this.selectAddress(JSON.parse(selectedAddress));
      }

      const billingAddress = localStorage.getItem('billingAddress');

      if (billingAddress) {
        this.selectBillingAddress(JSON.parse(billingAddress));
      }


      const selectedUpsMethod = localStorage.getItem('selectedUpsMethod');

      if (selectedUpsMethod) {
        this.selectUpsMethod(selectedUpsMethod);
      }

      const shippingAmount = localStorage.getItem('shippingAmount');

      if (shippingAmount) {
        this.setShippingAmount(shippingAmount);
      }

    }

  }

  public getCartCounts(params): void {
    this.appState$.dispatch(new cartAction.GetCartCount(params));
  }

  public setUserDetails(params): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('userDetails', JSON.stringify(params));
    }
    this.appState$.dispatch(new cartAction.SetUserDetails(params));
  }

  public doAddToCart(params): void {
    this.appState$.dispatch(new cartAction.AddToCart(params));
  }

  public setShippingMethods(params): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('shippingMethods', JSON.stringify(params));
    }
    this.appState$.dispatch(new cartAction.ShippingMethods(params));
  }

  public selectShippingMethod(params): void {

    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('shippingMethod', params);
    }

    this.appState$.dispatch(new cartAction.SelectShippingMethod(params));
  }

  public selectAddress(params): void {

    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('selectedAddress', JSON.stringify(params));
    }

    this.appState$.dispatch(new cartAction.SelectAddress(params));
  }

  public selectBillingAddress(params): void {

    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('billingAddress', JSON.stringify(params));
    }

    this.appState$.dispatch(new cartAction.SelectBillingAddress(params));
  }

  public selectUpsMethod(params): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('selectedUpsMethod', params);
    }
    this.appState$.dispatch(new cartAction.SelectUpsMethod(params));
  }


  public setShippingAmount(params): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('shippingAmount', params);
    }
    this.appState$.dispatch(new cartAction.SetShippingAmount(params));
  }

  public deleteFromCart(params): void {
    this.appState$.dispatch(new cartAction.DeleteFromCart(params));
  }

  public GetCartListList(params) {
    this.appState$.dispatch(new cartAction.GetCartList(params));
  }

}
